import { FC, ReactNode } from "react";
import { Loader } from "shared/components/Loader";
import { getErrorMessage } from "utils/error";

export const FetchBoundary: FC<{
  loading?: boolean;
  error?: Error | object | unknown;
  children?: ReactNode;
}> = (props) => {
  if (props.loading)
    return (
      <div className="animate-appear mx-auto mt-4">
        <Loader />
      </div>
    );

  if (props.error)
    return (
      <div className="text-base text-danger-400">
        {getErrorMessage(props.error)}
      </div>
    );

  return props.children || null;
};
